module.exports = __webpack_public_path__ + "static/media/DP_Embroidery_Sempione_GR Green_Ind.Blue_Peri.f552f855.png";